<template>
    <img class="logo object-contain" :src="logoSrc" alt="Logo">
</template>
<script>
const DEFAULT_LOGO = 'https://i.postimg.cc/HLVFSBtw/amoirie-benin.png'

export default {
    props: {
        name: String,
    },
    computed: {
        logoSrc() {
            const account = this.$page?.props?.auth?.current_account
            if (this.name === 'white') {
                return account?.logo_white || account?.logo || DEFAULT_LOGO
            }
            return account?.logo || DEFAULT_LOGO
        },
    },
}
</script>
